import { useEffect, useState } from "react";
import MobileHeader from "../../../layout/DriverLayout/Header";
import { Box, Typography, useTheme } from "@mui/material";
import checkinbanner from "../../../../media/images/checkin-banner.png";
import profileImage from "../../../../media/images/profileImage.svg";
import InfoCircle from "../../../../media/images/icons/info-circle";
import PlusMini from "../../../../media/images/icons/plus-mini";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../../components/CustomButton";
import CarTagView from "../../../components/CarTag";
import { useAppDispatch, useAppSelector } from "../../../../hooks/useRedux";
import useSWRMutation from "swr/mutation";
import { fetcherPost } from "../../../../services/fetcher";
import ApproveChackinBotomSheet from "./components/ApproveCheckinBottomSheet";
import ArrowLeftSVG from "../../../../media/images/icons/arrow-left";
import { useFormik } from "formik";
import TurnDetails from "./TurnDetails";
import {
  setDriverNobatQueueInfo,
  setQueueCount,
} from "../../../../redux/features/userSlice";
import { blueGrey, grey } from "@mui/material/colors";
import ChangeLoaderGroupModal from "./ChangeLoaderGroupModal";
import TruckFillSVG from "../../../../media/images/icons/truck-fill";
import BuildingSVG from "../../../../media/images/icons/building-icon";
import LoadingBox from "../../../components/LoadingBox";
export default function GetTurnPage() {
  const [openChangeLoader, setOpenChangeLoaderGroup] = useState(false);

  const theme = useTheme();

  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { salonInfo } = useAppSelector(
    (state) => state.user.driverNobatQueueInfo
  );

  const themeMode = useAppSelector((state) => state.settings.themeMode);

  const [approveState, setApproveState] = useState(false);

  const { fullName, vehicleInfo } = useAppSelector((state) => state.user);

  const {
    data: driverQData,
    trigger: getQInfo,
    isMutating: isGetQInfoMutating,
  } = useSWRMutation(
    [`/Nobat/GetQueueStatus`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: async (data) => {
        dispatch(setQueueCount(data.queueCount));
      },
    }
  );

  const { trigger: getDriverNobatQueueInfo } = useSWRMutation(
    [`/Nobat/GetDriverNobatQueueInfo`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: async (data) => {
        dispatch(
          setDriverNobatQueueInfo({
            ...data,
            queueCount: driverQData.queueCount,
          })
        );
      },
    }
  );

  const {
    trigger: getSalonListByDriverNobatHistory,
    isMutating: isGetSalonListByDriverNobatHistoryMutting,
  } = useSWRMutation(
    [
      `/Nobat/GetSalonListByDriverNobatHistory`,
      localStorage.getItem("access_token"),
    ],
    fetcherPost,
    {
      onSuccess: (salonsData) => {
        if (salonsData) {
          formik.setFieldValue("input", salonsData[0].salonCode);
          formik.setFieldValue("terminalName", salonsData[0].terminalName);
        }
      },
    }
  );

  const { data: getParkingCostByDriverData, trigger: getParkingCostByDriver } =
    useSWRMutation(
      [`/Nobat/GetParkingCostByDriver`, localStorage.getItem("access_token")],
      fetcherPost,
      {
        onSuccess: () => {
          setApproveState(true);
        },
      }
    );

  const { trigger: addCheckinByDriver } = useSWRMutation(
    [`/Nobat/AddByDriver`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: (data) => {
        setApproveState(false);

        getDriverNobatQueueInfo();

        formik.resetForm();

        getQInfo();

        dispatch(
          setDriverNobatQueueInfo({
            nobatCode: data.queueNr,
            nobatDate: new Date().toISOString(),
            salonInfo: {
              code: "",
              name: "",
            },
          })
        );
      },
    }
  );
  const formik = useFormik({
    initialValues: {
      input: "",
      terminalName: "",
    },
    onSubmit: (values) => {
      console.log(values);

      addCheckinByDriver({ input: values.input });
    },
  });

  useEffect(() => {
    getSalonListByDriverNobatHistory({
      pageNr: 1,
    });
  }, [salonInfo, getSalonListByDriverNobatHistory]);

  useEffect(() => {
    getQInfo();
  }, [getQInfo]);

  return (
    <>
      <ApproveChackinBotomSheet
        cost={getParkingCostByDriverData?.cost}
        onDismiss={() => setApproveState(false)}
        open={approveState}
        onOk={() => formik.handleSubmit()}
      />
      <ChangeLoaderGroupModal
        open={openChangeLoader}
        setOpen={setOpenChangeLoaderGroup}
      />

      {isGetQInfoMutating ? (
        <>
          <MobileHeader
            title={
              <Typography
                sx={{
                  fontWeight: 600,
                  color: "secondary.main",
                  fontSize: 16,
                }}
              >
                اعلام حضور{" "}
              </Typography>
            }
          />
          <LoadingBox />
        </>
      ) : salonInfo?.name ? (
        <TurnDetails />
      ) : (
        <>
          <MobileHeader
            title={
              <Typography
                sx={{
                  fontWeight: 600,
                  color: "secondary.main",
                  fontSize: 16,
                }}
              >
                اعلام حضور{" "}
              </Typography>
            }
          />
          <Box
            sx={{
              paddingX: "8px",
            }}
          >
            <Box
              sx={{
                width: "100%",
                borderRadius: "16px",
                backgroundColor: "primary.main",
                overflow: "hidden",
                display: "flex",
              }}
            >
              <Box
                sx={{
                  width: "100px",
                  backgroundImage: `url(${checkinbanner})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "150px",
                  backgroundPosition: "center",
                  transform: "rotate(-15deg)",
                }}
              ></Box>
              <Box
                sx={{
                  flex: 1,
                  paddingY: "8px",
                  paddingX: "4px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  //   border: "1px solid gray",
                }}
              >
                <Typography
                  sx={{
                    color: "#fff",
                    fontWeight: "600",
                  }}
                >
                  اعلام حضور
                </Typography>
                <Box
                  sx={{
                    borderRadius: "10px",
                    backgroundColor: theme.palette.primary[50],
                    display: "flex",
                    gap: "3px",
                    padding: "6px",
                  }}
                >
                  <InfoCircle size={18} color={theme.palette.primary.main} />
                  <Typography
                    sx={{
                      fontWeight: "600",
                      fontSize: "12px",
                      color: "primary.main",
                    }}
                  >
                    برای دریافت بار از بازارگاه نیاز است تا حضور خود را با
                    مشخصات وسیله نقلیه‌تان(ناوگان) در منطقه نزدیک ایستگاه اعلام
                    کنید.
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                marginTop: "8px",
                backgroundColor: "bgColor.white",
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                padding: "8px",
                border: "1px solid",
                borderColor: blueGrey[100],
                borderRadius: "16px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <img
                    style={{
                      width: "32px",
                      borderRadius: "50%",
                    }}
                    src={profileImage}
                    alt=""
                  />
                  <Typography
                    sx={{
                      color: "secondary.main",
                      fontWeight: "700",
                      fontSize: "14px",
                    }}
                  >
                    {fullName}
                  </Typography>
                </Box>
                <CarTagView />
              </Box>

              <Box
                sx={{
                  borderColor: blueGrey[100],
                  borderWidth: "0.5px",
                  borderStyle: "solid",
                  borderRadius: "10px",
                  backgroundColor: "bgColor.white",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "8px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <TruckFillSVG
                    color={themeMode === "light" ? grey[800] : "#fff"}
                  />
                  <Typography
                    sx={{
                      fontWeight: "700",
                      fontSize: "14px",
                    }}
                  >
                    نوع بارگیر:{" "}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <Typography
                    sx={{
                      color: "secondary.main",
                      fontWeight: "700",
                      fontSize: "14px",
                    }}
                  >
                    {vehicleInfo?.loaderTypeName || "-------"}
                  </Typography>

                  <CustomButton
                    // loading={loading}
                    onClick={() => navigate("../change-vehicle")}
                    flexDirection="row"
                    title="تغییر ناوگان"
                    justifyContent="center"
                    bgColor="primary.main"
                    fSize="12px"
                    px="6px"
                    py="8px"
                    borderRadius="10px"
                    icon2={<ArrowLeftSVG size={18} />}
                    mt="0px"
                  />
                </Box>
              </Box>
              <Box
                sx={{
                  borderColor: blueGrey[100],
                  borderWidth: "0.5px",
                  borderStyle: "solid",
                  borderRadius: "10px",
                  backgroundColor: "bgColor.white",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "8px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <TruckFillSVG
                    color={themeMode === "light" ? grey[800] : "#fff"}
                  />
                  <Typography
                    sx={{
                      fontWeight: "700",
                      fontSize: "14px",
                    }}
                  >
                    گروه بارگیر:{" "}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <Typography
                    sx={{
                      color: "secondary.main",
                      fontWeight: "700",
                      fontSize: "14px",
                    }}
                  >
                    {vehicleInfo?.loaderTypeGroup || "------"}
                  </Typography>

                  {/* <CustomButton
                    // loading={loading}
                    onClick={() => setOpenChangeLoaderGroup(true)}
                    flexDirection="row"
                    title="تغییر گروه"
                    justifyContent="center"
                    bgColor="primary.main"
                    fSize="12px"
                    px="6px"
                    py="8px"
                    borderRadius="10px"
                    icon2={<EditIcon size={18} />}
                    mt="0px"
                  /> */}
                </Box>
              </Box>
              <Box
                sx={{
                  borderColor: blueGrey[100],
                  borderWidth: "0.5px",
                  borderStyle: "solid",
                  borderRadius: "10px",
                  backgroundColor: "bgColor.white",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "8px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <BuildingSVG
                    color={themeMode === "light" ? grey[800] : "#fff"}
                  />
                  <Typography
                    sx={{
                      fontWeight: "700",
                      fontSize: "14px",
                    }}
                  >
                    نام سالن:{" "}
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    color: "secondary.main",
                    fontWeight: "700",
                    fontSize: "14px",
                  }}
                >
                  {isGetSalonListByDriverNobatHistoryMutting
                    ? "درحال دریافت..."
                    : formik.values.terminalName}
                </Typography>
              </Box>
              <CustomButton
                flexDirection="row-reverse"
                onClick={() => {
                  getParkingCostByDriver();
                }}
                title="آماده دریافت بار هستم"
                bgColor="primary.main"
                justifyContent="center"
                width="100%"
                fSize="16px"
                px="10px"
                py="12px"
                borderRadius="10px"
                icon1={<PlusMini size={32} />}
              />
              <Typography
                sx={{
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                با اعلام حضور، شما یک نوبت در بین دیگر رانندگان بر اساس زمانی که
                اعلام حضور می‌کنید دریافت خواهید کرد
              </Typography>
            </Box>
          </Box>
        </>
      )}
    </>
  );
}
